import React from 'react';

export default class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.closePopup = this.closePopup.bind(this);
    }

    closePopup() {
        if (typeof (this.props.closePopupAction) === 'function') {
            this.props.closePopupAction();
        }
        this.props.closeAction();
        //PopupService.closePopup(this);
    }

    render() {
        let width = this.props.width ? `${this.props.width}` : '250px';
        let height = this.props.width ? `${this.props.height}` : '150px';
        const closeBtnEnabled = this.props.closeButtonVisible === undefined ? true : this.props.closeButtonVisible;


        return <div className="app-popup-background">
                   <div style={{
                width: width,
                height: height,
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                margin: 'auto',
                borderRadius: 5
            }}>
                       <div style={{ height: '30px', width: '100%', position: 'relative' }}>
                           <div className="popup-header">{this.props.header}</div>
                    {closeBtnEnabled && <button type="button" className="popup-close-button" onClick={this.closePopup} />}
                </div>
                       <div id="popupChild">
                           {this.props.children}
                       </div>
                   </div>
               </div>;
    }
}